import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsForm from "./en-us/form.json";

export const localizationEnUsRequestCreate = {
  ...localizationEnUsHeader,
  ...localizationEnUsForm,
};
